import type { TFunction } from 'i18next'
import type { StaatidDrivlinjeRow } from './api'
import { DRIVLINJE_OPTIONS } from './api'

/** One fixed colour per drivlinje, readable on light and dark cards. */
export const DRIVLINJE_FARGE: Record<string, string> = {
  Elektrisk: '#06b6d4', // cyan-500
  Bensin: '#f59e0b', // amber-500
  Diesel: '#64748b', // slate-500
  Hybrid: '#8b5cf6', // violet-500
  'Ladbar hybrid': '#10b981', // emerald-500
}

export function drivlinjeLabel(t: TFunction<'staatid'>, gruppe: string): string {
  const opt = DRIVLINJE_OPTIONS.find(o => o.value === gruppe)
  return opt ? t(opt.labelKey) : gruppe
}

export type Point = { maned: string } & Record<string, number | string | null>

/** Month rows keyed by drivlinje, one per calendar month from the first to
 *  the last. A month missing for a drivlinje (fewer than 3 sales, left out by
 *  the API) has no value, so its line shows a gap — and a month missing for
 *  every drivlinje is still on the axis, so no line bridges it. */
export function toChartData(rows: StaatidDrivlinjeRow[]): Point[] {
  const byMonth = new Map<string, Point>()
  for (const r of rows) {
    for (const p of r.trend) {
      const point = byMonth.get(p.maned) ?? { maned: p.maned }
      point[r.drivstoff_gruppe] = p.median_dager
      byMonth.set(p.maned, point)
    }
  }
  const months = [...byMonth.keys()].sort()
  if (months.length === 0) return []
  const out: Point[] = []
  let [y, m] = months[0].split('-').map(Number)
  const last = months[months.length - 1]
  for (;;) {
    const key = `${y}-${String(m).padStart(2, '0')}`
    out.push(byMonth.get(key) ?? { maned: key })
    if (key >= last) break
    m += 1
    if (m > 12) { m = 1; y += 1 }
  }
  return out
}
